<div class="item user-block no-pointer">
    <!-- User picture-->
    <div class="user-block-picture show-pointer" [routerLink]="'/settings'">
        <div class="user-block-status">
            <img *ngIf="profile.pictureUrl" class="img-thumbnail rounded-circle" [src]="profile.pictureUrl" alt="Avatar" />
            <img *ngIf="!profile.pictureUrl" class="img-thumbnail rounded-circle" src={{settings.user.picture}} alt="Avatar" />
        </div>
    </div>
    <!-- Name and Job-->
    <div class="user-block-info show-pointer" [routerLink]="'/settings'">
        <span class="user-block-name">{{ profile.firstName }}&nbsp;{{ profile.name }}</span>
        <span class="user-block-role">{{ profile.jobTitle }}</span>
    </div>

</div>